import { render, staticRenderFns } from "./trace-detail.vue?vue&type=template&id=9059a304&scoped=true&"
import script from "./trace-detail.vue?vue&type=script&lang=ts&"
export * from "./trace-detail.vue?vue&type=script&lang=ts&"
import style0 from "./trace-detail.vue?vue&type=style&index=0&id=9059a304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9059a304",
  null
  
)

export default component.exports